module.exports = __webpack_public_path__ + "img/CellResearch.1d6e843a.png";